import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

import { cronList } from "../../../../../shared/scheduling";
import { cancelSchedule, listSchedules } from "../../../../schedules/api";

export const Route = createFileRoute("/_workspace/settings/schedules/")({
  component: SchedulesPage,
});

function fmtNext(nextRun: number | null): string {
  if (nextRun == null) return "—";
  return new Date(nextRun * 1000).toLocaleString();
}

function SchedulesPage() {
  const qc = useQueryClient();
  const schedules = useQuery({
    queryKey: ["schedules"],
    queryFn: listSchedules,
  });
  const cancel = useMutation({
    mutationFn: cancelSchedule,
    onSuccess: () => qc.invalidateQueries({ queryKey: ["schedules"] }),
  });

  return (
    <div className="mx-auto w-full max-w-3xl px-6 pt-8 pb-12">
      <h1 className="mb-1 text-lg font-semibold">Schedules</h1>
      <p className="mb-6 text-sm text-muted-foreground">
        Upcoming and recurring runs.
      </p>
      {schedules.isLoading ? (
        <p className="text-sm text-muted-foreground">Loading…</p>
      ) : schedules.error ? (
        <p className="text-sm text-destructive">
          {(schedules.error as Error).message}
        </p>
      ) : schedules.data && schedules.data.length > 0 ? (
        <ul className="divide-y divide-border rounded-md border border-border">
          {schedules.data.map((s) => (
            <li
              key={s.id}
              className="flex items-center justify-between gap-4 px-4 py-3"
            >
              <div className="min-w-0">
                <div className="truncate font-medium">{s.label}</div>
                <div className="text-xs text-muted-foreground">
                  {s.cron ? (
                    cronList(s.cron).map((cron) => (
                      <code key={cron} className="mr-2">
                        {cron}
                      </code>
                    ))
                  ) : (
                    <span className="mr-2">one-shot</span>
                  )}
                  <span>· next {fmtNext(s.nextRun)}</span>
                </div>
              </div>
              <button
                type="button"
                onClick={() => cancel.mutate(s.id)}
                disabled={cancel.isPending}
                className="shrink-0 rounded-md border border-border px-2 py-1 text-xs text-muted-foreground hover:bg-muted hover:text-foreground disabled:opacity-50"
              >
                Cancel
              </button>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-sm text-muted-foreground">
          No schedules yet. Skills schedule via their SKILL.md{" "}
          <code>schedule:</code> frontmatter; apps schedule from their own code.
        </p>
      )}
    </div>
  );
}
